import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

export interface NoWorkspaceAccessContext {
  organization_id: number;
  organization_name: string;
  owner_email: string;
  owner_name: string | null;
  has_workspace_access: boolean;
}

/**
 * Backing query for the `/no-workspace-access` landing page.
 *
 * Returns `null` when the calling user isn't in a managed organization
 * (404), or `has_workspace_access: true` once access is restored.
 */
export const useNoWorkspaceAccessContext = (enabled = true) => {
  const auth = useAuth();

  return useQuery<NoWorkspaceAccessContext | null>({
    queryKey: ["identity", "no-workspace-access-context"],
    enabled: Boolean(auth?.userToken) && enabled,
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.identity.no_workspace_access_context, {
        headers: {
          Authorization: `Bearer ${auth?.userToken ?? ""}`,
        },
      });
      if (response.status === 404) {
        return null;
      }
      return handleResponse(response);
    },
  });
};
